module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold-Rotalic.183ab6f8.eot";